<template>
  <section class="cohort-list">
    <div class="container">
      <div class="row">
        <div class="col-lg">
          <h2 class="title">
            {{ title }}
          </h2>
        </div>
      </div>
      <div class="card-grid">
        <template v-for="item in items" :key="item.system.id">
          <NuxtLink :to="siteStore.getUrlByItemId(item.system.id)" class="card-link">
            <div class="card">
              <div class="card-logo">
                <div v-if="item.elements.logo.value.length > 0" class="card-logo-wrapper">
                  <img :src="item.elements.logo.value[0]?.url" />
                </div>
                <div class="label-tags">
                  <div :class="getLabelClass(tag.codename)" v-for="tag in item.elements.harmonizedDataSetVersion.value">
                    {{ tag.name }}
                  </div>
                </div>
              </div>
              <div class="card-info">
                <h4 class="title-line-1 line-clamp">
                  {{ item.elements.cardTitleLine1.value }}

                  <div v-if="item.elements.cardTitleLine2.value.length > 0" class="title-line-2 line-clamp">
                    {{ item.elements.cardTitleLine2.value }}</div>
                </h4>
                <div class="card-info__content">
                  <div class="focus">
                    <label>Focus</label>
                    <div class="value line-clamp">{{ item.elements.researchFocus.value }}</div>
                  </div>
                  <div class="type">
                    <label>Type</label>
                    <div class="value line-clamp">{{ item.elements.studyType.value }}</div>
                  </div>
                </div>
              </div>
            </div>
          </NuxtLink>
        </template>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { taxonomies, type CohortItem2Model, type CohortListModel } from '~/models'
const pageStore = usePageStore()
const siteStore = useSiteStore()
const props = defineProps<{ model: CohortListModel }>()
const items = ref<CohortItem2Model[]>([])
const title = ref('')
items.value = [
  ...props.model.elements.cohorts.value.map((codename) =>
    pageStore.getLinkedItem<CohortItem2Model>(codename)
  )
]
title.value = props.model.elements.title.value

function getLabelClass(codename: string) {

  const map: { [key: string]: string } = {
    [taxonomies._harmonized_data_set_.terms.version_1.codename]: 'v1',
    [taxonomies._harmonized_data_set_.terms.version_2.codename]: 'v2'
  };

  return map[codename];
}
</script>
